import {
  type UseQueryOptions,
  type UseQueryResult,
  useQuery,
} from '@tanstack/react-query'

import { mockedAdminPermissions } from '@front/tests/mocks/data/permissions.mock'
import type { AdminPermissions } from '@front/type/admin'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminPermissionsUrl } from './config'

const AdminPermissionsQueryKey = 'admin-permissions'

const fetch = async () => {
  try {
    return axiosGet<AdminPermissions>(adminPermissionsUrl)
  } catch (err) {
    return mockedAdminPermissions
  }
}

export const useAdminPermissionsQuery = (
  options?: UseQueryOptions<AdminPermissions>,
): UseQueryResult<AdminPermissions> =>
  useQuery<AdminPermissions>({
    queryKey: [AdminPermissionsQueryKey],
    queryFn: fetch,
    ...options,
    refetchOnWindowFocus: 'always',
  })
